module.exports = {
    success: 'Success',
    clientChanged: 'Client changed',
    skuAdded: 'SKU set',
};
